"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIIconRating = _interopRequireDefault(require("UIComponents/input/UIIconRating"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UITextArea = _interopRequireDefault(require("UIComponents/input/UITextArea"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _HubspotUrls = _interopRequireDefault(require("../constants/HubspotUrls"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _ReviewerInfo = _interopRequireDefault(require("./ReviewerInfo"));

var _SaveButton = _interopRequireDefault(require("./SaveButton"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var ENTER = 13;
var MAX_CHARACTERS = 300;

var _default = _react.default.createClass({
  displayName: "ReviewInput",
  propTypes: {
    currentUserEmail: _react.PropTypes.string.isRequired,
    currentUserFullName: _react.PropTypes.string.isRequired,
    goodId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    parentId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    pageOpenedFrom: _react.PropTypes.string.isRequired,
    submitReviewStatus: _react.PropTypes.string.isRequired,
    submitReview: _react.PropTypes.func.isRequired,
    transactionId: _react.PropTypes.number
  },
  getInitialState: function getInitialState() {
    return {
      rating: 0,
      reviewText: ''
    };
  },
  handleReviewTextUpdate: function handleReviewTextUpdate(event) {
    if (event.target.value.length <= MAX_CHARACTERS) {
      this.setState({
        reviewText: event.target.value
      });
    }
  },
  isValidReview: function isValidReview() {
    return this.state.rating > 0 && this.state.reviewText.length > 0;
  },
  onRatingClick: function onRatingClick(event) {
    this.setState({
      rating: event.target.value
    });
  },
  onClickSubmit: function onClickSubmit() {
    var _this$props = this.props,
        goodId = _this$props.goodId,
        parentId = _this$props.parentId,
        pageOpenedFrom = _this$props.pageOpenedFrom,
        submitReview = _this$props.submitReview,
        transactionId = _this$props.transactionId;
    submitReview(goodId, transactionId, this.state.rating, this.state.reviewText, pageOpenedFrom, parentId);
  },
  preventEnter: function preventEnter(event) {
    if (event.keyCode === ENTER) {
      event.preventDefault();
    }
  },
  renderErrorAlert: function renderErrorAlert() {
    if (this.props.submitReviewStatus === _RequestStatusTypes.default.FAILED) {
      return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIAlert.default, {
        titleText: _I18n.default.text('reviewModal.submitError.header'),
        type: "danger"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "reviewModal.submitError.description"
      })));
    }

    return null;
  },
  render: function render() {
    var _this$props2 = this.props,
        currentUserEmail = _this$props2.currentUserEmail,
        currentUserFullName = _this$props2.currentUserFullName,
        submitReviewStatus = _this$props2.submitReviewStatus;
    return _react.default.createElement("div", {
      className: "integrate-review-input"
    }, _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIFlex.default, {
      justify: "between"
    }, _react.default.createElement("strong", null, _I18n.default.text('reviewModal.review')), _react.default.createElement(_UIIconRating.default, {
      onChange: this.onRatingClick,
      iconSize: "xxs"
    })), _react.default.createElement(_UITextArea.default, {
      className: "text-area-resize-vertical",
      rows: 6,
      placeholder: _I18n.default.text('reviewModal.commentPlaceholder'),
      onChange: this.handleReviewTextUpdate,
      onKeyDown: this.preventEnter,
      value: this.state.reviewText
    }), _react.default.createElement(_Small.default, {
      className: "text-right",
      tagName: "p",
      use: "help"
    }, (0, _langUtils.getCharactersRemainingText)(MAX_CHARACTERS, this.state.reviewText.length)), _react.default.createElement(_ReviewerInfo.default, {
      userEmail: currentUserEmail,
      userFullName: currentUserFullName
    })), this.renderErrorAlert(), _react.default.createElement(_UISection.default, {
      className: "m-bottom-10"
    }, _react.default.createElement("p", null, _react.default.createElement(_Small.default, {
      use: "help"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "reviewModal.legalAgreement",
      options: {
        reviewGuidelinesLink: _HubspotUrls.default.REVIEW_GUIDELINES,
        termsOfUseLink: _HubspotUrls.default.TERMS_OF_USE
      }
    }))), _react.default.createElement(_SaveButton.default, {
      buttonState: (0, _utils.getButtonState)(submitReviewStatus),
      disabled: !this.isValidReview() || submitReviewStatus === _RequestStatusTypes.default.PENDING,
      onClick: this.onClickSubmit,
      textPath: "reviewModal"
    })));
  }
});

exports.default = _default;
module.exports = exports.default;